import React, { Fragment } from 'react'
import ContractBulletItemPure from './contract-bullet-item.pure'
import ContractBulletHeaderPure from './contract-bullet-header.pure'
import { Grid } from '@material-ui/core'


/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
const ContractBulletPure = (props) => {
  return (
    <Fragment>
      <Grid item lg={12} md={12} sm={12} es={12} xs={12} >
        {/* <Grid container spacing={2}> */}
        <ContractBulletHeaderPure />
        <ContractBulletItemPure></ContractBulletItemPure>
        {/* <ListView
          style={{ color: '#484848' }}
          data={props.data}
          header={ContractBulletHeaderPure}
          item={ContractBulletItemPure}
        /> */}
        {/* <ContractBulletListPure
        {...props}
      /> */}
      </Grid>
    </Fragment>
  )
}

export { ContractBulletPure as default }
